import BasicLayoutV2 from '@/layouts/BasicV2';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

import {assetLibraryConfig, marketConfig} from '../layouts/config/leftSidebar';

const digitalHumanOfflineTipStartTime = new Date('2026-09-24T00:00:00+08:00').getTime();
const digitalHumanOfflineTipEndTime = new Date('2026-10-17T00:00:00+08:00').getTime();
const now = Date.now();
const digitalHumanOfflineTip = now >= digitalHumanOfflineTipStartTime && now < digitalHumanOfflineTipEndTime
    ? '带有「即将下线」标签的数字人形象版权到期，将于10月16日正式下线，下线后无法继续使用，建议您提前做好内容规划，尽快使用'
    : '';

export default [
    {
        path: '/user/:userid/assetsv2',
        name: 'assetsV2LibraryNew',
        component: BasicLayoutV2,
        children: [
            {
                path: '',
                name: 'assetsV2LibraryNew',
                component: () => import('@/layouts/ContentLayout'),
                props: {
                    leftNavConfig: assetLibraryConfig
                },
                children: [
                    {
                        path: 'video',
                        name: 'assetsV2LibraryVideo',
                        meta: {
                            title: '视频',
                            authorizedRole: 'digital_human_list',
                            sdkName: 'CSVideoListV2'
                        },
                        component: () => import('@/views/V2/AssetsLibrary/video/List')
                    },
                    {
                        path: 'image',
                        name: 'assetsV2LibraryImage',
                        meta: {
                            title: '图片',
                            authorizedRole: 'digital_human_list',
                            sdkName: 'CSImageListV2'
                        },
                        component: () => import('@/views/V2/AssetsLibrary/image/List')
                    },
                    {
                        path: 'text',
                        name: 'assetsV2LibraryText',
                        meta: {
                            title: '文案',
                            titleExtra: {
                                type: 'router',
                                name: 'textCreateTitleV2',
                                label: '前往一键生文'
                            },
                            authorizedRole: 'digital_human_list'
                        },
                        component: () => import('@/views/V2/AssetsLibrary/text/index'),
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                            import('../model/TextCreate')
                        )
                    },
                    {
                        path: 'script',
                        name: 'assetsV2LibraryScript',
                        meta: {
                            title: '脚本库',
                            titleExtra: {
                                type: 'router',
                                name: 'textCreateScriptV2',
                                label: '前往脚本生成'
                            },
                            authorizedRole: 'digital_human_list'
                        },
                        component: () => import('@/views/V2/AssetsLibrary/script/index'),
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                            import('../model/TextCreate')
                        )
                    },
                    {
                        path: 'rawimage',
                        name: 'assetsV2LibraryRawImage',
                        meta: {
                            title: '图片',
                            authorizedRole: 'digital_human_list'
                        },
                        component: () => import('@/views/V2/AssetsLibrary/rawImage/index.vue'),
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('myCreation', () =>
                            import('../model/myCreation')
                        )
                    },
                    {
                        path: 'rawvideo',
                        name: 'assetsV2LibraryRawVideo',
                        meta: {
                            title: '视频',
                            authorizedRole: 'digital_human_list'
                        },
                        component: () => import('@/views/V2/AssetsLibrary/rawVideo/index.vue'),
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('myCreation', () =>
                            import('../model/myCreation')
                        )
                    }
                ]
            }
        ]
    },
    {
        path: '/user/:userid/marketv2',
        name: 'marketV2',
        component: BasicLayoutV2,
        children: [
            {
                path: '',
                name: 'marketV2',
                component: () => import('@/layouts/ContentLayout'),
                props: {
                    leftNavConfig: marketConfig
                },
                children: [
                    {
                        path: 'digitalHuman',
                        name: 'digitalHumanListV2',
                        meta: {
                            title: '数字人模特',
                            titleTip: digitalHumanOfflineTip,
                            authorizedRole: 'digital_human_list',
                            sdkName: 'DigicListV2',
                            show: false
                        },
                        component: () => import('@/views/V2/Market/VideoTemplate')
                    },
                    {
                        path: 'digitalVoice',
                        name: 'digitalVoiceListV2',
                        meta: {
                            title: '智能语音',
                            authorizedRole: 'digital_human_list',
                            sdkName: 'VoiceListV2',
                            show: false
                        },
                        component: () => import('@/views/V2/Market/VideoTemplate')
                    },
                    {
                        path: 'videoTpl/old',
                        name: 'digitalVideoTemplateV2Old',
                        meta: {
                            title: '视频模板',
                            authorizedRole: 'digital_human_list',
                            sdkName: 'digitalVideoTemplate_v2',
                            show: false
                        },
                        component: () => import('@/views/V2/Market/VideoTemplate')
                    },
                    {
                        path: 'videoTpl',
                        name: 'digitalVideoTemplateV2',
                        meta: {
                            title: '视频模板',
                            authorizedRole: 'digital_human_list',
                            sdkName: 'digitalVideoTemplate_v2',
                            show: false
                        },
                        component: () => import('@/views/V2/Market/VideoTemplateNew'),
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'videoComposition', loader: () => import('../model/videoComposition')},
                            {name: 'digitalCommonModel', loader: () => import('../model/digitalCommon')}
                        ])
                    },
                    {
                        path: 'imageTpl',
                        name: 'imageTemplateV2',
                        meta: {
                            title: '图片模板',
                            authorizedRole: 'digital_human_list',
                            show: false
                        },
                        component: () => import('@/views/V2/Market/ImageTemplate')
                    }
                ]
            }
        ]
    }
];
